<section class="text-center">
  <app-initiatives-hero *ngIf="selectedInitiative"
                        [title]="selectedInitiative?.title"
                        [backgroundClass]="selectedInitiative?.bgClass"
                        [textClass]="selectedInitiative?.textClass"
                        [imgBannerUrl]="selectedInitiative?.imgBannerUrl"
                        [altImgBanner]="selectedInitiative?.altImgBanner"
                        [subtitle] ="selectedInitiative?.subtitle"></app-initiatives-hero>
  <app-initiatives-domain [domain]="domain" [showDomainInfo]="false"></app-initiatives-domain>

  <div class="container py-5">
    <h2 class="text-center fw-bold mb-5">{{ "Sigue estos pasos para comenzar" | translate }}</h2>
    <div class="row g-4 d-flex justify-content-center align-items-center row-steps">
      <!-- Paso 1 -->
      <div class="col-md-3 d-flex justify-content-center">
        <div class="step-card h-100">
          <div class="step-number">1</div>
          <p class="step-info fs-6 text-start">
            {{ "Crea tu usuario Akky, si tienes dudas puedes" | translate }}
            <a [href]="helpCenterAkkyUserCreateUrl" target="_blank">{{ "acceder a esta guía." | translate }}</a>
          </p>
          <div class="step-icon">
            <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/single-man-circle.svg' | blobstorage"
                 data-src="{{ '/images/hecho-en-mexico/iconos/single-man-circle.svg' | blobstorage }}"
                 alt="usuario" class="img-fluid mb-3 img-step-icon">
          </div>
        </div>
      </div>

      <!-- Paso 2 -->
      <div class="col-md-3 d-flex justify-content-center">
        <div class="step-card h-100">
          <div class="step-number">2</div>
          <p class="step-info fs-6 text-start">
            {{ "Agrega los datos del" | translate }} <strong>{{ "Contacto Registrante" | translate }}</strong> {{ "de tu dominio," | translate }}
            <a [href]="helpCenterAkkyRegistrantContactUrl" target="_blank">{{ "conoce más aquí." | translate }}</a>
          </p>
          <div class="step-icon">
            <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/programming-monitor-type-2.svg' | blobstorage"
                 data-src="{{ '/images/hecho-en-mexico/iconos/programming-monitor-type-2.svg' | blobstorage }}"
                 alt="monitor" class="img-fluid mb-3 img-step-icon">
          </div>
        </div>
      </div>

      <!-- Paso 3 -->
      <div #containerStep3 class="col-md-3 d-flex justify-content-center">
        <div class="step-card h-100">
          <div class="step-number">3</div>
          <p class="step-info  fs-6 text-start">
            {{ "Diseña tu página con el Creador de Sitios Akky," | translate }}
            <a [href]="helpCenterAkkyInitialConfigSiteUrl" target="_blank"> {{ "comienza con esta guía." | translate }}</a>
          </p>
          <div class="step-icon">
            <img loading="lazy" [src]="'/images/hecho-en-mexico/iconos/programming-browser-1.svg' | blobstorage"
                 data-src="{{ '/images/hecho-en-mexico/iconos/programming-browser-1.svg' | blobstorage }}"
                 alt="consola" class="img-fluid mb-3 img-step-icon">
          </div>
        </div>
      </div>

    </div>
  </div>

  <div #containerButtonStarted class="mt-2">
    <button *ngIf="showButtonStarted" id="startInitiativeButton" type="button" class="btn btn-primary btn-lg text-uppercase"
            (click)="goToDataPage()">
      {{ textButtonStarted | translate }}
    </button>
  </div>

  <div class="container my-5">
    <p class="video-hem mx-auto fs-6">
      {{'Cuando termines este proceso, tus servicios quedarán configurados en tu cuenta Akky para que empieces a usarlos de inmediato.' | translate }}
    </p>

    <p class="mb-5 video-hem mx-auto fs-6">
      {{'Si necesitas ayuda, no dudes en contactar a nuestro' | translate }} <a [href]="whatsAppUrl" target="_blank"> {{'equipo de soporte.' | translate }}</a>
    </p>

    <h2 class="fw-bold mb-5">
      {{ 'Conoce más de esta iniciativa, consulta nuestros:' | translate }}
    </h2>

    <a href="{{ termsConditionsPDF | blobstorage}}" target="_blank" class="btn btn-outline-dark rounded-pill px-4">
      {{ 'Términos y Condiciones' | translate }}
    </a>
  </div>

</section>
